import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./AboutUs.css";

const AboutUs = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onHomeContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutContainerClick = useCallback(() => {
    navigate("/aboutus");
  }, [navigate]);

  const onOurProductsTextClick = useCallback(() => {
    navigate("/our-products");
  }, [navigate]);

  const onButtonDesktopSecondaryClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const onButtonDesktopPrimaryClick = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  return (
    <div className="aboutus-div">
      <div className="nav-div4">
        <div className="logo1-div12" onClick={onLogo1ContainerClick}>
          <img className="vector-icon315" alt="" src="../vector.svg" />
          <img className="vector-icon316" alt="" src="../vector1.svg" />
          <img className="vector-icon317" alt="" src="../vector2.svg" />
          <img className="vector-icon318" alt="" src="../vector3.svg" />
          <img className="vector-icon319" alt="" src="../vector244.svg" />
          <img className="vector-icon320" alt="" src="../vector245.svg" />
          <img className="vector-icon321" alt="" src="../vector6.svg" />
          <img className="vector-icon322" alt="" src="../vector247.svg" />
          <img className="vector-icon323" alt="" src="../vector8.svg" />
          <img className="vector-icon324" alt="" src="../vector9.svg" />
          <img className="vector-icon325" alt="" src="../vector10.svg" />
          <img className="vector-icon326" alt="" src="../vector11.svg" />
          <img className="vector-icon327" alt="" src="../vector252.svg" />
          <img className="vector-icon328" alt="" src="../vector253.svg" />
          <img className="vector-icon329" alt="" src="../vector14.svg" />
          <img className="vector-icon330" alt="" src="../vector15.svg" />
          <img className="vector-icon331" alt="" src="../vector16.svg" />
          <img className="vector-icon332" alt="" src="../vector17.svg" />
          <img className="vector-icon333" alt="" src="../vector18.svg" />
          <img className="vector-icon334" alt="" src="../vector259.svg" />
          <img className="vector-icon335" alt="" src="../vector260.svg" />
          <img className="vector-icon336" alt="" src="../vector261.svg" />
          <img className="vector-icon337" alt="" src="../vector22.svg" />
          <img className="vector-icon338" alt="" src="../vector23.svg" />
          <img className="vector-icon339" alt="" src="../vector264.svg" />
          <b className="shuleeazy-b14">ShuleEazy</b>
        </div>
        <div className="frame-div213">
          <div className="frame-div214">
            <div className="home-div3" onClick={onHomeContainerClick}>
              <b className="home-b4">Home</b>
            </div>
            <div className="about-div3" onClick={onAboutContainerClick}>
              <b className="our-mission-b">About Us</b>
            </div>
            <div className="products-div5">
              <div className="frame-div215">
                <b className="our-products-b4" onClick={onOurProductsTextClick}>
                  Our Products
                </b>
                <img
                  className="outline-24px-chevron-down4"
                  alt=""
                  src="../outline-24px--chevrondown4.svg"
                />
              </div>
            </div>
            <div className="contact-div4">
              <b className="home-b4">Contact Us</b>
            </div>
          </div>
          <div className="frame-div216">
            <button
              className="buttondesktopsecondary6"
              onClick={onButtonDesktopSecondaryClick}
            >
              <b className="save-and-next39">log in</b>
            </button>
            <button
              className="buttondesktopprimary28"
              onClick={onButtonDesktopPrimaryClick}
            >
              <b className="save-and-next40">sign up</b>
            </button>
          </div>
        </div>
      </div>
      <div className="hero-div2">
        <div className="hero-div3">
          <div className="group-div">
            <div className="rectangle-div1" />
            <img className="image-1-icon" alt="" src="../image-1@2x.png" />
            <div className="frame-div217">
              <b className="our-mission-b">About Us</b>
            </div>
            <div className="frame-div218">
              <div className="contact-div4">
                <b className="our-mission-b">Our Mission</b>
              </div>
              <div className="to-provide-quality-and-afforda">
                <p className="to-provide">
                  To provide quality and affordable education to all students
                  and offer mentorship and better access to learning resources.
                </p>
                <p className="to-provide">&nbsp;</p>
                <p className="blank-line-p1">&nbsp;</p>
              </div>
            </div>
            <div className="frame-div220">
              <div className="contact-div4">
                <b className="our-mission-b">Our Vision</b>
              </div>
              <div className="shuleeazy-looks-to-inspire-ind">
                <p className="to-provide">
                  ShuleEazy looks to inspire individuals to engage with
                  technology, as well as to make education technology relevant,
                  interesting, and meaningful to learners.
                </p>
                <p className="to-provide">&nbsp;</p>
                <p className="blank-line-p1">&nbsp;</p>
              </div>
            </div>
          </div>
          <img className="image-2-icon" alt="" src="../image-2@2x.png" />
        </div>
      </div>
      <div className="about-us-div">
        <div className="who-we-are">
          <b className="our-mission-b">01.</b>
          <b className="who-we-are1">Who We Are</b>
          <div className="we-are-a-group-of-young-design">
            We are a group of young designers and developers hoping to make a
            change in the education sector of our country
          </div>
        </div>
        <div className="who-we-are">
          <b className="our-mission-b">02.</b>
          <b className="who-we-are1">What We Do</b>
          <div className="we-are-a-group-of-young-design">
            We have built a solution that solves the problem of overcrowding in
            classes, lack of mentorship and accessible education
          </div>
        </div>
        <div className="who-we-are">
          <b className="our-mission-b">03.</b>
          <b className="who-we-are1">How We Do It</b>
          <div className="we-are-a-group-of-young-design">
            We make education fun and accessible by offering quality and
            affordable live online classes. We also offer mentorship sessions
            and have an SMS Platform where students can learn for free
          </div>
        </div>
      </div>
      <div className="team-div">
        <b className="our-mission-b">Meet Our Team</b>
        <div className="the-team-div">
          <div className="peris-div">
            <img className="ellipse-icon9" alt="" src="../ellipse-2.svg" />
            <div className="frame-div222">
              <b className="our-mission-b">Peris Wambui</b>
              <b className="ux-designer-b">UX Designer</b>
            </div>
          </div>
          <div className="peris-div">
            <img className="ellipse-icon9" alt="" src="../ellipse-21.svg" />
            <div className="frame-div222">
              <b className="our-mission-b">Pius Kimathi</b>
              <b className="ux-designer-b1">Backend Developer</b>
            </div>
          </div>
          <div className="peris-div">
            <img className="ellipse-icon9" alt="" src="../ellipse-22.svg" />
            <div className="frame-div222">
              <b className="our-mission-b">Cephas Mutua</b>
              <b className="ux-designer-b1">Backend Developer</b>
            </div>
          </div>
          <div className="peris-div">
            <img className="ellipse-icon9" alt="" src="../ellipse-23.svg" />
            <div className="frame-div222">
              <b className="our-mission-b">Daisy Kirui</b>
              <b className="ux-designer-b">Frontend Developer</b>
            </div>
          </div>
          <div className="peris-div">
            <img className="ellipse-icon9" alt="" src="../ellipse-24.svg" />
            <div className="frame-div222">
              <b className="our-mission-b">Luke Kibiku</b>
              <b className="ux-designer-b">UX Designer</b>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-div4">
        <div className="frame-div227">
          <img
            className="outline-24px-chevron-down4"
            alt=""
            src="../antdesigncopyrightoutlined4.svg"
          />
          <b className="our-mission-b">2022 ShuleEazy, All Rights Reserved</b>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
